export default __webpack_public_path__ + "static/media/add.fc6ba0e4.svg";